// import React from "react";
// import foto from "../../src/assets/PNG/image_blog.png";
// import foto1 from "../../src/assets/PNG/blog__component2.png";
// import foto2 from "../../src/assets/PNG/image_profile.png";
// import foto3 from "../../src/assets/PNG/blogCard__image1.png";
// import foto4 from "../../src/assets/PNG/imageStatus__1.png";
// import foto5 from "../../src/assets/PNG/blogCard__image2.png";
// import foto6 from "../../src/assets/PNG/blogCard__image3.png";
// import foto7 from "../../src/assets/PNG/blogCard__image4.png";
// import foto8 from "../../src/assets/PNG/blogCard__image5.png";
// import foto9 from "../../src/assets/PNG/blogCard__image6.png";
// import { BlogCard } from "@/components";
// import ViewBlog from "./ViewBlog";

const Blog: React.FC = () => {
  return (
    <div className="blog">
      {/* <div className="blog__component1">
        <img className="blog__component1__background" src={foto} alt="image" />
        <h1 className="blog__component1__title">Insights</h1>
        <p className="blog__component1__subtitle">
          From market trends to expert insights, unlock knowledge for smarter
          exchanges
        </p>
      </div>
      <div className="green__line"></div>
      <div className="text__component2">Featured article</div>
      <div className="blog__component2">
        <div className="blog__component2__left">
          <img className="blog__component2__image" src={foto1} alt="imag1" />
        </div>

        <div className="blog__component2__right">
          <div className="blog__component2__right__text">
            <span className="blog__component2__right__text1">Fiat</span>
            <span className="blog__component2__right__text1">Knowledge</span>
            <span className="blog__component2__right__text1">News</span>
          </div>

          <div className="blog__component2__right__title">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
            pretium a nunc non sodales
          </div>

          <div className="blog__component2__right__subtitle">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
            pretium a nunc non sodales. Aenean tincidunt mi sit amet egestas
            mattis. Nulla vel nunc rhoncus, venenatis nisl bibendum, interdum
            nisl. Aenean pulvinar, magna sed blandit auctor, arcu lacus
            ullamcorper odio, ut ornare dolor nisi eu sapien. Aenean tempor
            vitae ligula at ornare. Ut dictum nibh quis egestas tempor. Nunc
            ipsum orci, laoreet at mauri
          </div>

          <div className="blog__component2__right__information">
            <img src={foto2} alt="image2" />
            <span className="blog__component2__right__name">Andrew Josh</span>
            <span className="blog__component2__right__date">June, 2023</span>
          </div>

          <div>
            <p className="blog__component2__right__more">
              Read more
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                  fill="#35BCAB"
                />
              </svg>
            </p>
          </div>
        </div>
      </div>

      <div className="line__component3"></div>

      <div className="blog__component3">
        <div className="blog__component3__title">
          <span className="blog__component3__title__text">Insights</span>
        </div>

        <div className="blog__component3__card">
          <BlogCard
            image={foto3}
            section="News"
            title="Lorem ipsum dolor sit amet, cons ectetur adipiscing elit."
            information="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus pretium a nunc non sodales. Aenean tincidunt mi sit amet egestas mattis. Nulla vel nunc rho"
            imageStatus={foto4}
            name="Gabriel Joshua"
            date="June, 2023"
            button="Read more"
          />

          <BlogCard
            image={foto5}
            section="News"
            title="Lorem ipsum dolor sit amet, cons ectetur adipiscing elit."
            information="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus pretium a nunc non sodales. Aenean tincidunt mi sit amet egestas mattis. Nulla vel nunc rho"
            imageStatus={foto4}
            name="Gabriel Joshua"
            date="June, 2023"
            button="Read more"
          />

          <BlogCard
            image={foto6}
            section="News"
            title="Lorem ipsum dolor sit amet, cons ectetur adipiscing elit."
            information="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus pretium a nunc non sodales. Aenean tincidunt mi sit amet egestas mattis. Nulla vel nunc rho"
            imageStatus={foto4}
            name="Gabriel Joshua"
            date="June, 2023"
            button="Read more"
          />

          <BlogCard
            image={foto7}
            section="News"
            title="Lorem ipsum dolor sit amet, cons ectetur adipiscing elit."
            information="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus pretium a nunc non sodales. Aenean tincidunt mi sit amet egestas mattis. Nulla vel nunc rho"
            imageStatus={foto4}
            name="Gabriel Joshua"
            date="June, 2023"
            button="Read more"
          />

          <BlogCard
            image={foto8}
            section="News"
            title="Lorem ipsum dolor sit amet, cons ectetur adipiscing elit."
            information="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus pretium a nunc non sodales. Aenean tincidunt mi sit amet egestas mattis. Nulla vel nunc rho"
            imageStatus={foto4}
            name="Gabriel Joshua"
            date="June, 2023"
            button="Read more"
          />

          <BlogCard
            image={foto9}
            section="News"
            title="Lorem ipsum dolor sit amet, cons ectetur adipiscing elit."
            information="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus pretium a nunc non sodales. Aenean tincidunt mi sit amet egestas mattis. Nulla vel nunc rho"
            imageStatus={foto4}
            name="Gabriel Joshua"
            date="June, 2023"
            button="Read more"
          />
        </div>

        <div className="numberPages">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="23"
            viewBox="0 0 21 23"
            fill="none"
          >
            <path
              d="M20.5875 22.0258L9.94115 11.3794L20.5801 0.740523L10.6482 0.738871L0.000150781 11.3869L10.6329 22.0196L20.5875 22.0258Z"
              fill="#35BCAB"
            />
          </svg>
          <p className="number">1</p>
          <p className="number">2</p>
          <p className="number">...</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
          >
            <path
              d="M0.562894 0.974215L11.2092 11.6206L0.570328 22.2595L10.5022 22.2611L21.1502 11.6131L10.5175 0.980402L0.562894 0.974215Z"
              fill="#35BCAB"
            />
          </svg>
        </div>

        <div className="line__footer__component3"></div>
      </div>
      <ViewBlog/> */}
    </div>
  );
};

export default Blog;
